
import './App.css';
import bg from './assets/images/welcomebg.png'
import bgImg from './assets/images/bgImg.png'
import MobbgImg from './assets/images/bgImgMob.png'
import { BrowserRouter } from 'react-router-dom';
import Routing from './Routing';

import welcomeScreenText from './assets/images/WelcomeScreenText.png'
import { useEffect, useState } from 'react';
function App() {
  const [loader, setLoader] = useState(true)
  useEffect(() => {
    const time = setTimeout(() => {
      setLoader(false)
    }, 3000)
    return () => {
      clearTimeout(time)
    }
  }, [])
  return <>
    <BrowserRouter basename = {"/selfie"}>
      {/* <video autoPlay muted loop className='absolute max-h-[100vh] w-full object-cover z-0' >
  <source src={bgGif}  type="video/mp4"/>
 </video> */}
      {/* <img src={bg} className='absolute top-0 min-h-[100vh] w-full object-cover z-0'></img> */}
      {loader ? <div className='flex w-full justify-center items-center min-h-[100vh]  animate-[fade_7s_linear_2s_1]' >
        {/*  */}
        {/* <video autoPlay muted loop className='absolute w-full  max-h-[100vh]  z-40' >
  <source src={welcomeScreen}  type="video/mp4"/>
 </video> */}
        <img src={bgImg} className='absolute w-full hidden md:block min-h-[100vh] h-full  z-40' />
        <img src={MobbgImg} className='absolute md:hidden block w-full min-h-[100vh] h-full  z-40' />
        <img src={welcomeScreenText} className='z-50 md:w-[300px] w-[250px]' />

        <svg xmlns="http://www.w3.org/2000/svg" className='animate-bounce z-50 bottom-10 absolute' width="45" height="60" viewBox="0 0 45 60" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M21.3474 45.767C21.3474 45.0645 21.8547 44.534 22.5266 44.534C23.1162 44.534 23.6646 45.0645 23.6646 45.767C23.6646 46.4265 23.1162 47 22.5266 47C21.8547 47 21.3474 46.4265 21.3474 45.767ZM30.9453 30.5556C31.2333 29.1075 30.3557 27.7885 28.9709 27.7885H25.2003C24.2405 27.8315 22.9379 27 22.9379 27V33.6237C22.9379 40.3333 26.4617 43.1864 28.0934 43.4444C28.3813 43.5735 28.6007 43.4875 28.2168 43.1864C25.9955 41.6953 24.693 38.1398 24.5696 35.1147V29.0645C25.0357 29.3656 25.9133 29.4086 25.9133 29.4086H29.2725C30.1501 29.4086 30.6163 29.724 30.9453 30.5556ZM14.0529 30.5556C13.765 29.1075 14.6837 27.7885 16.0274 27.7885H19.798C20.7989 27.8315 22.0604 27 22.0604 27V33.6237C22.0604 40.3333 18.5366 43.1864 16.9049 43.4444C16.617 43.5735 16.3976 43.4875 16.7815 43.1864C19.0027 41.6953 20.3053 38.1398 20.4287 35.1147V29.0645C19.9625 29.3656 19.085 29.4086 19.085 29.4086H15.7669C14.8893 29.4086 14.4232 29.724 14.0529 30.5556Z" fill="white" />
          <circle cx="22.5" cy="37.5" r="21.5" stroke="white" stroke-width="2" />
          <path d="M29.8773 4.20047L26.9817 0.275944C26.8572 0.122642 26.6704 0 26.4524 0H17.5476C17.3296 0 17.1428 0.0919812 17.0183 0.275944L14.1227 4.20047C13.9359 4.44576 13.967 4.78302 14.1849 4.99764L21.533 12.7854C21.6575 12.908 21.8132 13 22 13C22.1868 13 22.3425 12.9387 22.467 12.7854L29.8151 4.99764C30.033 4.78302 30.0641 4.44576 29.8773 4.20047ZM18.8864 5.21226L20.4432 9.78066L16.1465 5.21226H18.8864ZM22.5916 1.28774L23.6813 3.95519H20.3187L21.4084 1.28774H22.5916ZM23.7436 5.21226L22 10.3632L20.2564 5.21226H23.7436ZM25.1136 5.21226H27.8535L23.5568 9.78066L25.1136 5.21226ZM28.0715 3.92453H25.0824L23.9927 1.28774H26.1099L28.0715 3.92453ZM17.859 1.28774H19.9762L18.8864 3.95519H15.9285L17.859 1.28774Z" fill="white" />
        </svg>


      </div> :
        <div className='relative min-h-[100vh] h-full z-20' style={{ backgroundImage: "url(" + bg + ")" }}>
          <Routing />
        </div>}
    </BrowserRouter>
  </>


}

export default App;
